import { createSlice } from '@reduxjs/toolkit';

export const EditTicketSlice = createSlice({
  name: 'editTicket',
  initialState: {
    editedTicket: {},
    anomaliesNumber: 1,
    requireMailNotification: false,
    titleUpdateNotification: null,
    validationErrorsMultiLang: {},
    ticketStatus: '',
    ticketExistButNotVisible: false,
  },
  reducers: {
    setEditedTicket: (state, action) => {
      state.editedTicket = action.payload;
    },
    incrementAnomaliesNumber: (state) => {
      state.anomaliesNumber += 1;
    },
    decrementAnomaliesNumber: (state) => {
      state.anomaliesNumber -= 1;
    },
    initialAnomaliesNumber: (state) => {
      state.anomaliesNumber = 1;
    },
    setAnomaliesNumber: (state, action) => {
      state.anomaliesNumber = action.payload;
    },
    setRequireMailNotification: (state, action) => {
      state.requireMailNotification = action.payload;
    },
    setTitleUpdateNotification: (state, action) => {
      state.titleUpdateNotification = action.payload;
    },
    setValidationErrorsMultiLang: (state, action) => {
      state.validationErrorsMultiLang = action.payload;
    },
    setTicketStatus: (state, action) => {
      state.ticketStatus = action.payload;
    },
    setTicketExistButNotVisible: (state, action) => {
      state.ticketExistButNotVisible = action.payload;
    },
  },
});
export const {
  setEditedTicket,
  incrementAnomaliesNumber,
  initialAnomaliesNumber,
  setAnomaliesNumber,
  decrementAnomaliesNumber,
  setRequireMailNotification,
  setTitleUpdateNotification,
  setValidationErrorsMultiLang,
  setTicketStatus,
  setTicketExistButNotVisible,
} = EditTicketSlice.actions;

export const editedTicketState = (state) => state.editTicket.editedTicket;
export const anomaliesNumberState = (state) => state.editTicket.anomaliesNumber;
export const requireMailNotificationState = (state) =>
  state.editTicket.requireMailNotification;
export const titleUpdateNotificationState = (state) =>
  state.editTicket.titleUpdateNotification;
export const validationErrorsMultiLangState = (state) =>
  state.editTicket.validationErrorsMultiLang;
export const ticketStatusState = (state) => state.editTicket.ticketStatus;
export const ticketExistButNotVisibleState = (state) =>
  state.editTicket.ticketExistButNotVisible;

export default EditTicketSlice.reducer;
